import extendNode from '../extendNode.mjs'
import useAbstractNode from '../_ABSTRACT/useAbstractNode.jsx'
import meta from './metaDe_1.mjs'
import FormChoose from './FormChooseDe_1.jsx'
import TableChoose from './TableChooseDe_1.jsx'
import api from './apiDe_1.mjs'

export default () => {
    const AbstractNode = useAbstractNode()

    return extendNode(AbstractNode, {
        ...meta,
        api,
        FormChoose,
        TableChoose,
    })
}
